import { useContext } from "react";

import { DynamicSurveysContext } from "../contexts/DynamicsSurveys.Context";

export function useDynamicsurveys() {
  const context = useContext(DynamicSurveysContext);

  return context;
}
